import { cva, type VariantProps } from 'class-variance-authority';

export const textVariants = cva(['font-brand'], {
  variants: {
    variant: {
      h1: 'text-h1',
      h2: 'text-h2',
      h3: 'text-h3',
      h4: 'text-h4',
      mixedH3H4: 'text-h3 md:text-h4',

      highlighted: 'text-highlighted',

      body1: 'text-body-1',
      body2: 'text-body-2',
      body3: 'text-body-3',
      richText: 'text-body-1 md:text-body-2',

      button: 'text-button',
    },
    weight: {
      bold: 'font-bold',
      semi: 'font-semibold',
      normal: 'font-light',
      default: '',
    },
    accent: {
      none: '',
      responsive: 'heading-accent-responsive',
      fixedLeft: 'heading-accent',
      centered: 'heading-accent-centered',
    },
    spacing: {
      none: '',
      small: 'mb-a',
      paragraph: 'mb-d',
    },
  },
  defaultVariants: {
    variant: 'body1',
    weight: 'default',
    accent: 'none',
    spacing: 'none',
  },
});

export type TextVariants = VariantProps<typeof textVariants>;
